import { apiClient, tokenStorage } from './apiClient';
import { response } from './apiHelpers';

export const authService = {
  async login(username, password) {
    const payload = await apiClient.post(
      'auth/login/',
      { username, password },
      { authenticated: false }
    );
    tokenStorage.set(payload);
    return response(payload.user);
  },
  async getCurrentUser() {
    return response(await apiClient.get('auth/me/'));
  },
  async changePassword(payload) {
    return response(await apiClient.post('auth/change-password/', payload));
  },
  async logout() {
    const refresh = tokenStorage.getRefresh();
    try {
      if (refresh) await apiClient.post('auth/logout/', { refresh }, { retry: false });
    } finally {
      tokenStorage.clear();
    }
  },
  hasSession: () => Boolean(tokenStorage.getAccess() || tokenStorage.getRefresh()),
};
